import React, { useState, useEffect, useRef, useContext } from "react";
import { MDBInput, MDBRow, MDBCol, MDBTextArea } from "mdb-react-ui-kit";
import URLAPI from "../../helpers/Path";
import axios from "axios";
import Alerts from "../Alerts";
import { Alert, Button, Form } from "react-bootstrap";

import {
  AutoComplete_Create,
  AutoComplete_Destroy,
} from "../js/AutoComplete.js";

const DeleteC = () => {
  // Bool para que el evento no se ejecute el doble si el usuario le presiona mientras se esta concluyendo el evento en un boton
  const [loading, setLoading] = useState(false);
  //Endpoint para obtener información del cliente seleccionado
  const clientesearchphp = URLAPI + "info_cliente.php";
  //Endpoint para obtener todos los clientes
  const clientesphp = URLAPI + "trae_clientes.php";
  //Estado que guardara todos los clientes
  const [clientes, setClientes] = useState([]);
  //Estado que guardara el nombre de la busqueda realizada
  const [busqueda, setBusqueda] = useState("");
  //Estado que guardara el id del cliente seleccionado
  const [idcliente, setIdcliente] = useState("");
  //Estado del Alert para cuando no se ha seleccionado ningun cliente
  const [isAlert, setIsAlert] = useState(false);
  //Estado del Alert para cuando el cliente se elimino de forma correcta
  const [isAlert2, setIsAlert2] = useState(false);
  //Estado del Alert que te pone si estas seguro de eliminar ese cliente
  const [isAlert3, setIsAlert3] = useState(false);
  //Variable de estado para recargar la pagina
  const [isCreated, setIsCreated] = useState(false);
  //Endpoint que se encarga de eliminar los clientes
  const elimina_cliente = URLAPI + "elimina_cliente.php";
  //Referencia para el autocomplete
  const inputRef = useRef(null);
  //Este useEffect se encarga de obtener todos los clientes desde el backend
  //Inicializa un autocompletado con hasta 10 clientes maximo
  useEffect(() => {
    const getClientes = async () => {
      try {
        const res = await axios.get(clientesphp);
        const clientesArray = Object.entries(res.data).map(([id, nombre]) => ({
          id,
          nombre,
        }));
        setClientes(clientesArray);

        if (inputRef.current) {
          AutoComplete_Create(inputRef.current.id, clientesArray, 10);
        }
      } catch (error) {
        console.error("Error al obtener clientes:", error);
      }
    };

    getClientes();
    //Si se desmonta el componente, se destruye
    return () => {
      if (inputRef.current) {
        AutoComplete_Destroy(inputRef.current.id);
      }
    };
  }, []);
  // --------------------------------------------------------------------------------------------------------

  // Funcion que se usa par recargar la pagina cuando se aparece el alert de guardado exitoso

  useEffect(() => {
    if (isCreated) {
      window.location.reload();
    }
  }, [isCreated]);
  // -------------------------------------------------------------------------------------------------------------

  // Maneja la selección del autocomplete
  useEffect(() => {
    if (!inputRef.current) return;

    const handleSelect = async () => {
      setTimeout(async () => {
        const idSeleccionado = inputRef.current.dataset.id; // ID del cliente seleccionado
        const nombreSeleccionado = inputRef.current.value; // Nombre mostrado en el input

        if (idSeleccionado) {
          //console.log("📌 ID seleccionado:", idSeleccionado);
          setIdcliente(idSeleccionado);
          setBusqueda(nombreSeleccionado);
          setIsAlert3(true);

          /*  try {
              const res = await axios.post(clientesearchphp, {
                data: idSeleccionado,
              });
              console.log("Datos de la cuenta:", res.data);
  
              setIdClienteSeleccionado(idSeleccionado);
              setDatosCliente(res.data);
            } catch (error) {
              console.error("Error recuperando datos:", error);
            }*/
        }
      }, 0);
    };

    // ------------------------------------------------------------------------------------------------------------

    // Escucha teclas enter o space y la selección de texto en un input y llama a la función handleselect donde se obtiene la información de ese cliente
    const handleKeyDown = (e) => {
      if (e.code === "Space" || e.code === "Enter") {
        e.preventDefault();
        handleSelect();
      }
    };

    inputRef.current.addEventListener("keydown", handleKeyDown);
    inputRef.current.addEventListener("select", handleSelect);
    //Cuando se desmonta el componente, quita los listener para evitar problemas
    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener("change", handleSelect);
      }
    };
  }, [clientes, clientesearchphp]);
  // --------------------------------------------------------------------------------------------------------------------

  // Funcion asincrona para borrar el cliente seleccionado
  const delete_cliente = async () => {
    setLoading(true); // Para que el boton no se ejecute el evento dos veces
    if (!idcliente) {
      setIsAlert(true);
      //alert("Selecciona un cliente primero");
      return;
    }
    //console.log("Id que se va a eliminar: ", idcliente);

    try {
      const res = await axios.post(elimina_cliente, { id_cliente: idcliente });
      if (res.data) {
        //alert("Cliente eliminado correctamente");
        setBusqueda("");
        setIdcliente("");
        if (res.data > 0) {
          setIsAlert2(true);
        }

        //window.location.reload();
      } else {
        alert("No se pudo eliminar el cliente");
      }
    } catch (error) {
      console.error("Error al eliminar cliente:", error);
      alert("Error al eliminar cliente");
    }
  };
  // ------------------------------------------------------------------------------------------------------

  return (
    <>
      <hr />

      {isAlert2 ? (
        <Alerts
          isShow={isAlert2}
          variant="success"
          head="Aviso"
          msg="Cliente eliminado correctamente"
          clicked={() => setIsCreated(true)}
          textButton="OK"
        />
      ) : (
        <div>
          <h5 className="mt-3">Eliminar información de un cliente</h5>
          <p>
            Para eliminar la información de un cliente, realize la busqueda
            comenzando por el apellido paterno, luego el materno y a final el
            nombre.
          </p>

          <MDBRow>
            <MDBCol>
              <MDBInput
                id="clienteInput"
                ref={inputRef}
                type="text"
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                label="Ap. paterno, Ap. materno, Nombre"
                wrapperClass="w-100"
              />
              <MDBInput
                type="text"
                placeholder="ID Cliente"
                style={{
                  padding: "5px",
                  width: "100px",
                  marginLeft: "10px",
                  display: "none",
                }}
                value={idcliente}
                readOnly
              />
            </MDBCol>
          </MDBRow>

          <MDBRow className="mt-4">
            {isAlert && (
              <Alerts
                isShow={isAlert}
                variant="danger"
                head="Error"
                msg="No se ha seleccionado un cliente"
                clicked={() => setIsAlert(false)}
                textButton="OK"
                variantButton={"outline-danger"}
              />
            )}
          </MDBRow>

          <MDBRow className="mt-4">
            {isAlert3 && (
              <Alert show={isAlert3} variant="warning" className="mt-3">
                <Alert.Heading>Alerta</Alert.Heading>
                <p>¿Estás seguro de eliminar el cliente {busqueda}?</p>
                <hr />
                <div className="d-flex justify-content-end">
                  <Button
                    onClick={() => {
                      window.location.reload();
                    }}
                    variant="outline-danger"
                    className="m-2 col-md-2"
                  >
                    NO
                  </Button>
                  <Button
                    onClick={() => {
                      delete_cliente();
                      //window.location.reload();
                    }}
                    disabled={loading}
                    variant="outline-success"
                    className="m-2 col-md-2"
                  >
                    SI
                  </Button>
                </div>
              </Alert>
            )}
          </MDBRow>

          <MDBRow className="d-flex justify-content-between align-items-center my-4">
            <MDBCol className="col-auto">
              <button
                className="btn btn-warning"
                onClick={() => window.location.reload()}
                style={{
                  borderRadius: "8px",
                  fontWeight: "bold",
                }}
              >
                ⟵
              </button>
            </MDBCol>
          </MDBRow>
        </div>
      )}
    </>
  );
};

export default DeleteC;
